import React, { useState, useEffect, useContext } from 'react'

import * as StringFormatter from '../../../../global/formatters/string-formatter.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'

import Loader from '../../../../components/FundDetails/Modules/Shared/Loader.jsx'

import {
  updateArray,
  titleCase,
  getTabNames,
  stickyOnScroll,
} from '../helpers/InvestmentProductsHelper.js'

import { get529Data } from '../InvestmentProductsDataSource.js'
import {
  getSelectedClass,
  sortByAge,
  parseDataTarget,
  parseDataAge,
} from '../helpers/FiveTwoNineUtility.js'

import FilterHeader from '../../../../components/PageHeader/FilterHeader.jsx'
import { LayoutContext } from '../../../utility/index.js'
import { removeSpecialCharacters } from '../../../utility/index.js'

import '../InvestmentProducts.css'
import { FutureScholarPortfoliosMobile } from './FutureScholarPortfoliosMobile.jsx'
import { ProductContext } from '../ProductContext.jsx'

export default function FutureScholarPortfolios() {
  const DEFAULT_CLASS = 'A'

  const classes = [
    {
      className: 'A',
    },
    {
      className: 'C',
    },
    {
      className: 'E',
    },
    {
      className: 'I',
    },
  ]
  const [funds, setFunds] = useState([])
  const [fundsFiltered, setFundsFiltered] = useState([])
  const [selectedSection, setSelectedSection] = useState(
    '#target-allocation-single-fund-portfolios'
  )
  const [selectedFundSearch, setFundSearch] = useState('')
  const [selectedClass, setSelectedClass] = useState(getSelectedClass(classes))
  const [selectedPerformanceType, setSelectedPerformanceType] = useState('puv')
  const [selectedPerformanceFrequency, setSelectedPerformanceFrequency] =
    useState('performanceMonthly')
  const [selectedDisplayGroup, setSelectedDisplayGroup] = useState(false)
  const [isFilterOn, setIsFilterOn] = useState(false)
  const [selectedSort, setSelectedSort] = useState('name')
  const [selectedSortDirection, setSelectedSortDirection] = useState(true)
  const [selectedSortType, setSelectedSortType] = useState('string')
  const [selectedGroups, setSelectedGroups] = useState([])
  const [filterUpdatedValue, setFilterUpdatedValue] = useState({})
  const [makeDataCalls, setMakeDataCalls] = useState(false)
  const [initializeFundsDataCall, setInitializeFundsDataCall] = useState(false)
  const [isDataLoading, setIsDataLoading] = useState(true)
  const [tableHeaderTop, setTableHeaderTop] = useState()
  const { isMobile, tabs, changeTab, selectedTabKey } =
    useContext(ProductContext)

  const layout = useContext(LayoutContext)

  const getAspect = (section) => {
    const aspects = [
      {
        name: '#target-allocation-single-fund-portfolios',
        info: {
          tag:
            selectedPerformanceFrequency === 'performanceMonthly'
              ? 'Monthly'
              : 'Quarterly',
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'products',
              isArray: false,
            },
          ],
          getData: get529Data,
          parseData: parseDataTarget,
          processData: () => {
            setSelectedDisplayGroup(false)
            setSelectedSort('name')
            setSelectedSortType('name')
          },
          renderOptions: () => {
            return (
              <>
                <div className="u-flex u-flexAlignItemsCenter u-sm-flexColReverse">
                  <div className="u-flex u-sm-flexCol u-flexAlignItemsCenter u-sm-flexAlignItemsStart u-marginVert4gu u-sm-flexAlignItemsStretch u-size1of2 u-sm-sizeFull">
                    {isMobile && tabs && (
                      <div className="Dropdown u-marginBottom4gu">
                        <label
                          className="Form-label u-hiddenVisually"
                          htmlFor="productDropdown"
                        >
                          Data Categories
                        </label>
                        <select
                          className="Dropdown-menu"
                          id="productDropdown"
                          value={selectedTabKey}
                          onChange={(e) => {
                            const value = e.target.value
                            window.location.hash = value
                            changeTab(value)
                          }}
                        >
                          {tabs.map((tab) => (
                            <option key={tab.key} value={tab.key}>
                              {tab.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    {renderPerformanceOptions({
                      performance_dropdown: 'performance_dropdown',
                      frequency_dropdown: 'frequency_portfolio',
                    })}
                    {renderClassOptions({
                      class_dropdown: 'class_portfolio',
                    })}
                  </div>
                  <div className="u-flex u-flexAlignItemsCenter u-size1of2 u-sm-sizeFull u-flexAuto u-sm-marginLeft0 u-marginLeft4gu u-sm-marginTop2gu">
                    {renderSearch()}
                  </div>
                </div>

                <div className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween">
                  <div className="Form-label">
                    Displaying{' '}
                    <span className="u-textBold">
                      {isFilterOn
                        ? (fundsFiltered && fundsFiltered.length) || 0
                        : (funds && funds.length) || 0}
                    </span>{' '}
                    products(s)
                  </div>
                </div>
              </>
            )
          },
          headerSummary1: () => {
            return (
              <>
                Average Annual Total Returns (%)
                <br />
                {funds.length > 0
                  ? 'as of ' +
                    StringFormatter.formatDateStandard(funds[0].asOfDate)
                  : ''}
              </>
            )
          },
          headerSummary2: () => {
            return (
              <>
                Expense Ratio
                <br />
                {funds.length > 0 ? 'as of' : ''}
                <br />
                {funds.length > 0
                  ? StringFormatter.formatDateStandard(funds[0].expenseAsOfDate)
                  : ''}
              </>
            )
          },
          colSpan1: 4,
          colSpan2: 6,
          colSpan3: 2,
          columns: [
            {
              name: 'name',
              className:
                'Table-header sorting' +
                (selectedSort === 'name'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Name: activate to sort column descending',
              content: <>Name</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'name' ? ' Icon--before' : ''),
                sort: 'name',
                sortType: 'string',
              },
              cell: {
                content: (fund) => (
                  <a
                    className="u-textBold u-sm-textNone"
                    href={`${getRelativeBasePath()}/investment-products/529-plan/${StringFormatter.urlSafe(
                      removeSpecialCharacters(fund.name)
                    )}/Class-${fund.className}/details/?cusip=${fund.cusip}`}
                  >
                    {fund.name}
                  </a>
                ),
              },
            },
            {
              name: 'className',
              className: 'Table-header sorting_disabled',
              ariaLabel: 'Pricing Alternative',
              content: (
                <div className="u-padding2gu u-textRight">
                  Pricing Alternative
                </div>
              ),
              cell: {
                className: 'u-textRight',
                content: (fund) => <>{fund.className}</>,
              },
            },
            {
              name: 'value',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvVal'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel:
                'PUV $ as of ' +
                StringFormatter.formatDateStandard(
                  funds.length > 0 ? funds[0].puvDate : ''
                ) +
                ': activate to sort column',
              content: (
                <>
                  PUV $ as of
                  <br />
                  {StringFormatter.formatDateStandard(
                    funds.length > 0 ? funds[0].puvDate : ''
                  )}
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvVal' ? ' Icon--before' : ''),
                sort: 'puvVal',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.puvVal,
              },
            },
            {
              name: 'ytd',
              className:
                'Table-header u-textRight sorting bordered' +
                (selectedSort === 'ytd'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel:
                'YTD % as of ' +
                StringFormatter.formatDateStandard(
                  funds.length > 0 ? funds[0].ytdAsOfDate : ''
                ) +
                ': activate to sort column',
              content: (
                <>
                  YTD % PUV as of
                  <br />
                  {StringFormatter.formatDateStandard(
                    funds.length > 0 ? funds[0].ytdAsOfDate : ''
                  )}
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'ytd' ? ' Icon--before' : ''),
                sort: 'ytd',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.ytd,
              },
            },
            {
              name: '1year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvOneYear' || selectedSort === 'popOneYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '1 Year: activate to sort column',
              content: <>1 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvOneYear' ||
                  selectedSort === 'popOneYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvOneYear'
                    : 'popOneYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvOneYear
                    : fund.popOneYear,
              },
            },
            {
              name: '3year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvThreeYear' ||
                selectedSort === 'popThreeYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '3 Year: activate to sort column',
              content: <>3 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvThreeYear' ||
                  selectedSort === 'popThreeYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvThreeYear'
                    : 'popThreeYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvThreeYear
                    : fund.popThreeYear,
              },
            },
            {
              name: '5year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvFiveYear' ||
                selectedSort === 'popFiveYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '5 Year: activate to sort column',
              content: <>5 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvFiveYear' ||
                  selectedSort === 'popFiveYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvFiveYear'
                    : 'popFiveYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvFiveYear
                    : fund.popFiveYear,
              },
            },
            {
              name: '10year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvTenYear' || selectedSort === 'popTenYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '10 Year: activate to sort column',
              content: <>10 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvTenYear' ||
                  selectedSort === 'popTenYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvTenYear'
                    : 'popTenYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvTenYear
                    : fund.popTenYear,
              },
            },
            {
              name: 'inception',
              className:
                'Table-header u-textNoWrap u-textRight sorting' +
                (selectedSort === 'puvSinceInception' ||
                selectedSort === 'popSinceInception'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Since Inception: activate to sort column',
              content: (
                <>
                  Since
                  <br />
                  Incept. *
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvSinceInception' ||
                  selectedSort === 'popSinceInception'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvSinceInception'
                    : 'popSinceInception',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvSinceInception
                    : fund.popSinceInception,
              },
            },
            {
              name: 'inceptionDate',
              className:
                'Table-header u-textNoWrap u-textRight sorting bordered' +
                (selectedSort === 'inceptionDt'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Inception Date: activate to sort column',
              content: (
                <>
                  Incept.
                  <br />
                  Date
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'inceptionDt' ? ' Icon--before' : ''),
                sort: 'inceptionDt',
                sortType: 'date',
              },
              cell: {
                className: 'u-textNoWrap u-textRight',
                content: (fund) =>
                  StringFormatter.formatDateStandard(fund.inceptionDt),
              },
            },
            {
              name: 'gross',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'grossExp'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Net: activate to sort column',
              content: <>Gross</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'grossExp' ? ' Icon--before' : ''),
                sort: 'grossExp',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.grossExp,
              },
            },
            {
              name: 'net',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'netExp'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Gross: activate to sort column',
              content: <>Net</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'netExp' ? ' Icon--before' : ''),
                sort: 'netExp',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.netExp,
              },
            },
          ],
        },
      },
      {
        name: '#age-based-portfolios',
        info: {
          tag:
            selectedPerformanceFrequency === 'performanceMonthly'
              ? 'Monthly'
              : 'Quarterly',
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'products',
              isArray: false,
            },
          ],
          getData: get529Data,
          parseData: parseDataAge,
          processData: () => {
            setSelectedDisplayGroup(true)
            setSelectedSort('ageGroup')
            setSelectedSortType('age')
          },
          renderOptions: () => {
            return (
              <div className="u-flex u-sm-flexCol u-flexAlignItemsCenter u-sm-flexAlignItemsStart u-marginVert4gu u-sm-flexAlignItemsStretch">
                <div className="u-lg-flex u-md-flex u-flexAuto u-sm-flexCol u-flexAlignItemsCenter u-sm-flexAlignItemsStart">
                  {isMobile && tabs && (
                    <div className="Dropdown u-marginBottom4gu">
                      <label
                        className="Form-label u-hiddenVisually"
                        htmlFor="productDropdown"
                      >
                        Data Categories
                      </label>
                      <select
                        className="Dropdown-menu"
                        id="productDropdown"
                        value={selectedTabKey}
                        onChange={(e) => {
                          const value = e.target.value
                          window.location.hash = value
                          changeTab(value)
                        }}
                      >
                        {tabs.map((tab) => (
                          <option key={tab.key} value={tab.key}>
                            {tab.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {renderPerformanceOptions({
                    performance_dropdown: 'performance_age',
                    frequency_dropdown: 'frequency_age',
                  })}
                  {renderClassOptions({
                    class_dropdown: 'class_age',
                  })}
                </div>
              </div>
            )
          },
          headerSummary1: () => {
            return (
              <>
                Average Annual Total Returns (%)
                <br />
                {funds.length > 0
                  ? 'as of ' +
                    StringFormatter.formatDateStandard(funds[0].asOfDate)
                  : ''}
              </>
            )
          },
          headerSummary2: () => {
            return (
              <>
                Expense Ratio
                <br />
                {funds.length > 0 ? 'as of' : ''}
                <br />
                {funds.length > 0
                  ? StringFormatter.formatDateStandard(funds[0].expenseAsOfDate)
                  : ''}
              </>
            )
          },
          colSpan1: 5,
          colSpan2: 6,
          colSpan3: 2,
          columns: [
            {
              name: 'group',
              className: 'Table-header sorting_disabled',
              ariaLabel: '',
              content: <>&nbsp;</>,
              cell: {
                content: () => <div></div>,
              },
            },
            {
              name: 'name',
              className:
                'Table-header sorting' +
                (selectedSort === 'ageGroup'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Name',
              content: <>Name</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingRight3gu' +
                  (selectedSort === 'ageGroup' ? ' Icon--before' : ''),
                sort: 'ageGroup',
                sortType: 'age',
              },
              cell: {
                content: (fund) => <div>Ages {fund.ageGroup}</div>,
              },
            },
            {
              name: 'className',
              className: 'Table-header sorting_disabled',
              ariaLabel: 'Pricing Alternative',
              content: (
                <div className="u-padding2gu u-textRight">
                  Pricing Alternative
                </div>
              ),
              cell: {
                className: 'u-textRight',
                content: (fund) => <>{fund.className}</>,
              },
            },
            {
              name: 'value',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvVal'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel:
                'PUV $ as of ' +
                StringFormatter.formatDateStandard(
                  funds.length > 0 ? funds[0].puvDate : ''
                ) +
                ': activate to sort column',
              content: (
                <>
                  PUV $ as of
                  <br />
                  {StringFormatter.formatDateStandard(
                    funds.length > 0 ? funds[0].puvDate : ''
                  )}
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvVal' ? ' Icon--before' : ''),
                sort: 'puvVal',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.puvVal,
              },
            },
            {
              name: 'ytd',
              className:
                'Table-header u-textRight sorting bordered' +
                (selectedSort === 'ytd'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel:
                'YTD % as of ' +
                StringFormatter.formatDateStandard(
                  funds.length > 0 ? funds[0].ytdAsOfDate : ''
                ) +
                ': activate to sort column',
              content: (
                <>
                  YTD % PUV as of
                  <br />
                  {StringFormatter.formatDateStandard(
                    funds.length > 0 ? funds[0].ytdAsOfDate : ''
                  )}
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'ytd' ? ' Icon--before' : ''),
                sort: 'ytd',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.ytd,
              },
            },
            {
              name: '1year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvOneYear' || selectedSort === 'popOneYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '1 Year: activate to sort column',
              content: <>1 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvOneYear' ||
                  selectedSort === 'popOneYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvOneYear'
                    : 'popOneYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvOneYear
                    : fund.popOneYear,
              },
            },
            {
              name: '3year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvThreeYear' ||
                selectedSort === 'popThreeYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '3 Year: activate to sort column',
              content: <>3 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvThreeYear' ||
                  selectedSort === 'popThreeYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvThreeYear'
                    : 'popThreeYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvThreeYear
                    : fund.popThreeYear,
              },
            },
            {
              name: '5year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvFiveYear' ||
                selectedSort === 'popFiveYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '5 Year: activate to sort column',
              content: <>5 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvFiveYear' ||
                  selectedSort === 'popFiveYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvFiveYear'
                    : 'popFiveYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvFiveYear
                    : fund.popFiveYear,
              },
            },
            {
              name: '10year',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'puvTenYear' || selectedSort === 'popTenYear'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: '10 Year: activate to sort column',
              content: <>10 Yr</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvTenYear' ||
                  selectedSort === 'popTenYear'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvTenYear'
                    : 'popTenYear',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvTenYear
                    : fund.popTenYear,
              },
            },
            {
              name: 'inception',
              className:
                'Table-header u-textNoWrap u-textRight sorting' +
                (selectedSort === 'puvSinceInception' ||
                selectedSort === 'popSinceInception'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Since Inception: activate to sort column',
              content: (
                <>
                  Since
                  <br />
                  Incept. *
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'puvSinceInception' ||
                  selectedSort === 'popSinceInception'
                    ? ' Icon--before'
                    : ''),
                sort:
                  selectedPerformanceType === 'puv'
                    ? 'puvSinceInception'
                    : 'popSinceInception',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) =>
                  selectedPerformanceType === 'puv'
                    ? fund.puvSinceInception
                    : fund.popSinceInception,
              },
            },
            {
              name: 'inceptionDate',
              className:
                'Table-header u-textNoWrap u-textRight sorting bordered' +
                (selectedSort === 'inceptionDt'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Inception Date: activate to sort column',
              content: (
                <>
                  Incept.
                  <br />
                  Date
                </>
              ),
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'inceptionDt' ? ' Icon--before' : ''),
                sort: 'inceptionDt',
                sortType: 'date',
              },
              cell: {
                className: 'u-textNoWrap u-textRight',
                content: (fund) =>
                  StringFormatter.formatDateStandard(fund.inceptionDt),
              },
            },
            {
              name: 'gross',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'grossExp'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Net: activate to sort column',
              content: <>Gross</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'grossExp' ? ' Icon--before' : ''),
                sort: 'grossExp',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.grossExp,
              },
            },
            {
              name: 'net',
              className:
                'Table-header u-textRight sorting' +
                (selectedSort === 'netExp'
                  ? selectedSortDirection
                    ? ' is-ascending'
                    : ' is-descending'
                  : ''),
              ariaLabel: 'Gross: activate to sort column',
              content: <>Net</>,
              button: {
                className:
                  'Table-headerNode u-padding2gu u-paddingLeft3gu u-textRight' +
                  (selectedSort === 'netExp' ? ' Icon--before' : ''),
                sort: 'netExp',
                sortType: 'number',
              },
              cell: {
                className: 'u-textRight',
                content: (fund) => fund.netExp,
              },
            },
          ],
        },
      },
    ]

    return aspects.find((a) => a.name === (section || selectedSection))?.info
  }

  useEffect(() => {
    getParentTab()
    stickyOnScroll(setTableHeaderTop)
    if (location?.hash) {
      setSelectedSection(location?.hash)
    }
  }, [])

  useEffect(() => {
    if (makeDataCalls && selectedSection === window.location.hash) {
      setInitializeFundsDataCall(true)
    }
  }, [
    makeDataCalls,
    initializeFundsDataCall,
    selectedSection,
    window.location.hash,
  ])

  useEffect(() => {
    if (initializeFundsDataCall) {
      initializeFunds()
    }
  }, [
    selectedSection,
    initializeFundsDataCall,
    selectedClass,
    selectedPerformanceFrequency,
  ])

  useEffect(() => {
    initializeFundsFiltered()
  }, [selectedFundSearch])

  useEffect(() => {
    if (funds && funds.length > 0) {
      window.prerenderReady = true
    }
  }, [funds])

  // Determine which tab this component maps to
  const getParentTab = async () => {
    const tabData =
      (await getTabNames('529.plan'))?._embedded?.documents[0]?.bundles
        ?.default || []
    const tabDataKeys = Object.keys(tabData)
    const match = tabDataKeys.find((key) => key.includes(layout.container))
    if (match) {
      setSelectedSection(match.replace(/.*\./, '#'))
      setMakeDataCalls(true)
    }
  }

  const sortFunds = (fundsArray) => {
    fundsArray.sort((fund1, fund2) => {
      const a = selectedSortDirection ? fund1 : fund2
      const b = selectedSortDirection ? fund2 : fund1

      // Sort by 'group' first if applicable
      if (selectedDisplayGroup) {
        const glidePathOrder = {
          AGGRESSIVE: 'A',
          MODERATE: 'B',
          CONSERVATIVE: 'C',
        }

        const categoryCompare = (
          glidePathOrder[a['glidePath']] || ''
        ).localeCompare(glidePathOrder[b['glidePath']] || '', 'en', {
          sensitivity: 'base',
        })

        if (categoryCompare) {
          return categoryCompare
        }
      }

      // Sort by selected sort
      switch (selectedSortType) {
        case 'number': {
          const aValue =
            typeof a[selectedSort] === 'string'
              ? parseFloat(a[selectedSort] === '-' ? 0.0 : a[selectedSort])
              : a[selectedSort]
          const bValue =
            typeof b[selectedSort] === 'string'
              ? parseFloat(b[selectedSort] === '-' ? 0.0 : b[selectedSort])
              : b[selectedSort]

          const sortValue = aValue < bValue ? -1 : aValue > bValue ? 1 : 0

          // Sort by Age if two numbers are the same
          if (!sortValue) {
            return sortByAge(fund1, fund2)
          }

          return sortValue
        }
        case 'array':
          return (a[selectedSort][0] || '').localeCompare(
            b[selectedSort][0] || '',
            'en',
            { sensitivity: 'base' }
          )
        case 'age':
          return sortByAge(a, b)
        default:
          return (a[selectedSort] || '').localeCompare(
            b[selectedSort] || '',
            'en',
            { sensitivity: 'base' }
          )
      }
    })

    return fundsArray
  }

  const initializeFundsFiltered = (fundsArray) => {
    const _funds = fundsArray || funds

    if (
      selectedFundSearch &&
      selectedSection === '#target-allocation-single-fund-portfolios'
    ) {
      const _fundsFiltered = _funds.filter((fund) => {
        // Search
        const fundSearchTest =
          !selectedFundSearch ||
          removeSpecialCharacters(fund.name)
            .toLowerCase()
            .indexOf(
              removeSpecialCharacters(selectedFundSearch).toLowerCase()
            ) > -1

        // Does fund meet all tests?
        return fundSearchTest
      })

      setIsFilterOn(true)

      setFundsFiltered(_fundsFiltered)
    } else {
      setIsFilterOn(false)

      setFundsFiltered([])
    }
  }

  const initializeFunds = async () => {
    let selectedClassDropdown = {}

    if (
      selectedSection === '#age-based-portfolios' &&
      filterUpdatedValue.class_age
    ) {
      selectedClassDropdown = { className: filterUpdatedValue.class_age }
    } else if (
      selectedSection === '#target-allocation-single-fund-portfolios' &&
      filterUpdatedValue.class_portfolio
    ) {
      selectedClassDropdown = { className: filterUpdatedValue.class_portfolio }
    } else {
      selectedClassDropdown = { className: DEFAULT_CLASS }
    }

    const aspect = getAspect(location.hash)

    if (aspect) {
      const data = await aspect?.getData(
        aspect.tag,
        (selectedClassDropdown && selectedClassDropdown.className) ||
          DEFAULT_CLASS
      )

      let _funds = aspect?.selector?.reduce(
        (prev, curr) => (curr.isArray ? prev[curr.name][0] : prev[curr.name]),
        data
      )

      if (aspect?.parseData) {
        _funds = aspect.parseData(_funds)
      }

      if (aspect?.processData) {
        aspect.processData(_funds)
      }

      setFunds(_funds)
      setIsDataLoading(false)
      initializeFundsFiltered(_funds)
    }
  }

  const onChangeFundSearch = (event) => {
    setFundSearch(event.currentTarget.value)
  }

  const updatedDropDownValue = (event) => {
    return setFilterUpdatedValue({
      ...filterUpdatedValue,
      [event.target.id]: event.currentTarget.selectedOptions[0].value,
    })
  }

  const onChangeFundClassDropdown = (event) => {
    const _selectedClass = classes.find(
      (fundClass) =>
        fundClass.className === event.currentTarget.selectedOptions[0].value
    )

    setSelectedClass(_selectedClass)
    setIsDataLoading(true)
    updatedDropDownValue(event)
  }

  const onChangePerformanceTypeDropdown = (event) => {
    setSelectedPerformanceType(event.currentTarget.selectedOptions[0].value)

    updatedDropDownValue(event)
  }

  const onChangePerformanceFrequencyDropdown = (event) => {
    setSelectedPerformanceFrequency(
      event.currentTarget.selectedOptions[0].value
    )
    setIsDataLoading(true)
    updatedDropDownValue(event)
  }

  const onClickSort = (event) => {
    const sort = event.currentTarget.dataset.sort
    const sortType = event.currentTarget.dataset.sortType

    setSelectedSortType(sortType)

    if (sort === selectedSort) {
      setSelectedSortDirection(!selectedSortDirection)
    } else {
      setSelectedSort(sort)
      setSelectedSortDirection(true)
    }
  }

  const onClickToggleGroup = (event) => {
    const group = event.currentTarget.dataset.group

    updateArray(selectedGroups, group, selectedGroups.indexOf(group) < 0)

    setSelectedGroups([...selectedGroups])
  }

  const renderClassOptions = (obj) => {
    return (
      <div className="u-flex u-sm-flexCol u-flexAlignItemsCenter u-sm-flexAlignItemsStart u-marginLeft5gu u-sm-marginLeft0 u-sm-flexAlignItemsStretch">
        <label
          className="Form-label u-marginBottom0 u-sm-hidden"
          htmlFor="class_dropdown"
        >
          Class
        </label>
        <div className="Dropdown u-marginLeft2gu u-sm-marginLeft0">
          <label className="u-hiddenVisually" htmlFor={obj.class_dropdown}>
            {obj.class_dropdown}
          </label>
          <select
            id={obj.class_dropdown}
            value={filterUpdatedValue[obj.class_dropdown]}
            className="Dropdown-menu"
            onChange={onChangeFundClassDropdown}
          >
            {classes && classes.length > 0
              ? classes.map((fundClass) => {
                  return (
                    <option
                      key={fundClass.className}
                      value={fundClass.className}
                    >
                      {fundClass.className}
                    </option>
                  )
                })
              : null}
          </select>
        </div>
      </div>
    )
  }

  const renderPerformanceOptions = (obj) => {
    return (
      <div
        className={`u-flex ${isMobile ? 'Grid--withGutter Grid--alignBottom u-marginBottom4gu' : ''}`}
      >
        <div className="u-sm-size1of2 u-md-flex u-lg-flex u-lg-flexAlignItemsCenter u-md-flexAlignItemsCenter">
          <label
            className="Form-label u-marginBottom0 u-sm-hidden"
            htmlFor="performance_dropdown"
          >
            Performance
          </label>
          <div className="Dropdown u-sm-marginLeft0 u-marginLeft2gu u-sm-marginVert1gu">
            <select
              id={obj.performance_dropdown}
              className="Dropdown-menu"
              value={filterUpdatedValue[obj.performance_dropdown]}
              onChange={onChangePerformanceTypeDropdown}
            >
              <option value="puv">PUV</option>
              <option value="pop">POP</option>
            </select>
          </div>
        </div>
        <div className="u-sm-size1of2 u-md-flex u-lg-flex u-lg-flexAlignItemsCenter u-md-flexAlignItemsCenter">
          <div className="Dropdown u-sm-marginLeft0 u-marginLeft2gu u-sm-marginVert1gu">
            <label
              className="u-hiddenVisually"
              htmlFor={obj.frequency_dropdown}
            >
              Frequency
            </label>
            <select
              id={obj.frequency_dropdown}
              className="Dropdown-menu"
              value={filterUpdatedValue[obj.frequency_dropdown]}
              onChange={onChangePerformanceFrequencyDropdown}
            >
              <option value="performanceMonthly">MONTHLY</option>
              <option value="performanceQuarterly">QUARTERLY</option>
            </select>
          </div>
        </div>
      </div>
    )
  }

  const renderSearch = () => {
    return (
      <FilterHeader
        placeholder="Search 529 plan"
        onSearch={onChangeFundSearch}
        defaultSearchText={selectedFundSearch}
        pushSearchInline={true}
        mode={isMobile ? 'mobile product-landing on-key-press' : ''}
      />
    )
  }

  const renderColumnHeader = (column) => {
    return (
      <th
        key={column.name}
        className={column.className + ' u-bgColorBrandDark'}
        role="columnheader"
        aria-controls="mutual-funds-table"
        aria-label={column.ariaLabel}
      >
        {column.button ? (
          <button
            className={column.button.className}
            data-sort={column.button.sort}
            data-sort-type={column.button.sortType}
            onClick={onClickSort}
          >
            {column.content}
            {/* TODO: add as part of table refactor (CTINEXT-2040)
            <span aria-hidden="true" className="adel-material-symbols-20">
              unfold_more
            </span> */}
          </button>
        ) : (
          <>{column.content}</>
        )}
      </th>
    )
  }

  const renderColumnCell = (column, fund) => {
    return (
      <td
        key={column.name + fund.cusip}
        className={
          'Table-cell u-paddingRight2gu ' + (column.cell.className || '')
        }
      >
        {column.cell.content(fund)}
      </td>
    )
  }

  const aspect = getAspect()

  let runningGlidePath = ''
  const _funds = isFilterOn ? fundsFiltered : funds

  return (
    <div className="529-plan-table">
      {aspect && (
        <div className="u-sizeConstrained Content">
          {/* OPTIONS */}
          <div>{aspect?.renderOptions()}</div>
          {/* TABLE */}
          {/* Need design to know what to do for age based */}
          {_funds?.length > 0 && !isDataLoading ? (
            // Should this be refactored into its own component? FutureScholarPortfoliosMobile?
            isMobile ? (
              <FutureScholarPortfoliosMobile
                funds={_funds}
                selectedSection={selectedSection}
                selectedPerformanceType={selectedPerformanceType}
                sortByAge={sortByAge}
              />
            ) : (
              <table
                className={
                  'Table Table--reversed Table--sortable u-sm-block u-overflowX InvestmentProductTable'
                }
              >
                <thead
                  className="Table-head is-sticky"
                  style={{
                    top: tableHeaderTop,
                  }}
                >
                  <tr role="row" className="Table-row">
                    <th
                      colSpan={aspect.colSpan1}
                      className="Table-header u-bgColorBrandDark u-alignTop bordered"
                      role="columnheader"
                    ></th>
                    <th
                      colSpan={aspect.colSpan2}
                      className="Table-header u-bgColorBrandDark u-padding2gu u-alignTop u-textNoWrap bordered"
                      role="columnheader"
                    >
                      {aspect.headerSummary1()}
                    </th>
                    <th
                      colSpan={aspect.colSpan3}
                      className="Table-header u-bgColorBrandDark u-padding2gu u-alignTop u-textNoWrap"
                      role="columnheader"
                    >
                      {aspect.headerSummary2()}
                    </th>
                  </tr>
                  <tr role="row" className="Table-row">
                    {aspect.columns
                      .filter((column) => !column.hide)
                      .map((column) => renderColumnHeader(column))}
                  </tr>
                </thead>
                <tbody className="Table-body">
                  {_funds.length < 1 ? (
                    <tr className="Table-row">
                      <td className="Table-cell" colSpan={12}>
                        No funds found with the selected filters.
                      </td>
                    </tr>
                  ) : (
                    sortFunds(isFilterOn ? fundsFiltered : funds).map(
                      (fund) => {
                        const glidePath = fund.glidePath || ''

                        const showGroup = glidePath !== runningGlidePath

                        runningGlidePath = glidePath

                        return (
                          <React.Fragment
                            key={fund.cusip + glidePath + fund.ageGroup}
                          >
                            {selectedDisplayGroup && showGroup ? (
                              <tr
                                className="Table-row-group"
                                data-group={glidePath}
                                onClick={onClickToggleGroup}
                              >
                                <td className="Table-cell u-textCenter">
                                  <div
                                    className={
                                      'u-textSizeMsrp4' +
                                      (selectedGroups.indexOf(glidePath) < 0
                                        ? ' Table-row-group-iconOpen'
                                        : '')
                                    }
                                  >
                                    {selectedGroups.indexOf(glidePath) < 0
                                      ? '-'
                                      : '+'}
                                  </div>
                                </td>
                                <td className="Table-cell u-textBold u-textNoWrap">
                                  {titleCase(glidePath)} Track
                                </td>
                                <td className="Table-cell" colSpan={11}></td>
                              </tr>
                            ) : null}
                            {!selectedDisplayGroup ||
                            selectedGroups.indexOf(glidePath) < 0 ? (
                              <tr className="Table-row" role="row">
                                {aspect.columns
                                  .filter((column) => !column.hide)
                                  .map((column) =>
                                    renderColumnCell(column, fund)
                                  )}
                              </tr>
                            ) : null}
                          </React.Fragment>
                        )
                      }
                    )
                  )}
                </tbody>
              </table>
            )
          ) : (
            <Loader showBackground={false} />
          )}
        </div>
      )}
      <div id="ampf-trace-loaded-page"></div>
    </div>
  )
}
